// extracted by mini-css-extract-plugin
export default {"controls":"DishTechCardDownload_controls__qNydR","placeHolderShimmer":"DishTechCardDownload_placeHolderShimmer__8VCPl"};